@if (
  {
    cart: cart$ | async,
  };
  as data
) {
  <button
    mat-button
    [matMenuTriggerFor]="cartMenu"
    title="{{ 'Mini shopping cart' | translate | async }}"
  >
    <mat-icon svgIcon="cart-outline"></mat-icon>
    @if (data.cart?.items_qty) {
      <span class="badge cart-badge">
        {{ data.cart?.items_qty }}
      </span>
    }
  </button>
  <mat-menu #cartMenu="matMenu" class="cart-dropdown">
    @if (data.cart?.items_qty) {
      <div>
        <div class="cart-dropdown__scroll-content">
          @for (row of data.cart?.items; track row) {
            <div class="cart-dropdown__item">
              <div class="cart-dropdown__item-image">
                <a [sRouterLink]="['product', row.url_key]">
                  @if (!row.thumbnail || row.thumbnail === 'no_selection') {
                    <img loading="lazy" [src]="placeholder" alt="{{ row.name }}" />
                  }
                  @if (row.small_image && row.small_image !== 'no_selection') {
                    <img
                      loading="lazy"
                      [src]="mediaUrl + row.small_image"
                      alt="{{ row.name }}"
                    />
                  }
                </a>
              </div>
              <div class="cart-dropdown__item-content">
                <a
                  class="product-item-name"
                  [sRouterLink]="['product', row.url_key]"
                  [innerHtml]="row.name"
                ></a>
                @if (row.options && row.options.length) {
                  <dl class="item-options">
                    @for (option of row.options; track option) {
                      <dd>{{ option.label }}:</dd>
                      <dd [innerHTML]="option.value"></dd>
                    }
                  </dl>
                }
                <div class="item-options">
                  <span>{{ 'Qty' | translate | async }}</span
                  >: {{ row.qty }}
                </div>
              </div>
              <div class="cart-dropdown__item-price">
                <app-currency></app-currency>
                <app-price [price]="getRowTotal(row)"></app-price>
              </div>
              <div class="cart-dropdown__item-delete">
                <mat-icon (click)="deleteItem(row, $event)">close</mat-icon>
              </div>
            </div>
          }
        </div>
        <div class="cart-dropdown__info">
          <span class="cart-dropdown__subtotal">
            <span>{{ 'Cart Subtotal' | translate | async }}:</span>
            <span
              ><app-currency></app-currency>
              <app-price [price]="getSubtotal(data.cart!)"></app-price
            ></span>
          </span>
        </div>
        <div class="cart-dropdown__footer">
          <app-speedy-link-button
            url="cart"
            type="outline"
            text="View Cart"
          ></app-speedy-link-button>
          <app-speedy-link-button
            url="checkout"
            type="primary"
            text="Go to checkout"
          ></app-speedy-link-button>
        </div>
        @if (loading) {
          <div class="cart-dropdown__loading">
            <mat-spinner diameter="35"></mat-spinner>
          </div>
        }
      </div>
    } @else {
      @if (!data.cart?.items_qty) {
        <p class="cart-dropdown__empty">
          {{ 'You have no items in your shopping cart.' | translate | async }}
        </p>
      }
    }
  </mat-menu>
}
